import { Routes, Route, Navigate } from "react-router-dom";

import styles from "../common/Page.module.css";
import SideMenuStatic from "Page/common/SideMenuStatic";
import Blanform from "./Blanform/Balnform";
import Syringepump from "./Syringepump/Syringepump";
import Cleanterbox from "./Clenterbox/Cleanterbox";

export default function ProductPage() {
  const menus = [
    { title: "블랜폼", to: "blanform/item" },
    { title: "시린지펌프", to: "syringepump/item" },
    { title: "클린터박스", to: "cleanterbox/item" },
  ];

  return (
    <div className={styles.Page}>
      <SideMenuStatic title="제품 소개" menus={menus} />
      <div className={styles.ContentContainer}>
        <Routes>
          <Route path="/blanform/:category" element={<Blanform />} />
          <Route path="/syringepump/:category" element={<Syringepump />} />
          <Route path="/cleanterbox/:category" element={<Cleanterbox />} />
          <Route path="/*" element={<Navigate replace to="blanform/item" />} />
        </Routes>
      </div>
    </div>
  );
}
